import React from 'react'
import { useEffect } from 'react'
import { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Link, useParams } from 'react-router-dom'
import { addQuickService, getSingleQuickService } from '../../actions'

const AddQuickService = () => {

    const [QuickService, setQuickService] = useState({
        quickService: '',
        priority: '',
        active: '',
    })
	const [dataEdit, setDataEdit] = useState(false)
	
	const {quickService} = useParams()

	console.log("quickServicequickService", quickService);
    const dispatch = useDispatch()

    const handleChange = ( e ) => {
        const {name, value} = e.target;
        setQuickService({...QuickService, [name]:value})
    }

	// useEffect(() => {
	// 	dispatch(getSingleQuickService())
	// },[])

	const singleQuickService = useSelector(state => state.home.getSingleQuick)

    const onSave = () => {
        const data = {
            active: QuickService.active === 'true' ? true : false,
            priority: QuickService.priority,
            quickService: QuickService.quickService,
            // media: {}
        }
        dispatch(addQuickService(data))
    }

  return (
    <div className=''>
				<div className='col-md-6'>
					<div className='form-group row'>
						<div className='col-sm-9'></div>
					</div>
				</div>
				<div className='m-4'>
				<h1>Add Quick Services</h1>
					
			</div>
			

				<div className='card-body'>
				
					<div className='row'>
						<div className='col-md-6'>
							<div className='form-group row'>
								<label className='col-sm-3 col-form-label'>
									Quick Service
								</label>
								<div className='col-sm-9'>
									<input
										type='text'
										className='form-control'
										name='category'
										id='BusinessCategory'
										placeholder='Quick Service'
										onChange={handleChange}
										// value={AddCategory.category}
									/>
								</div>
							</div>
						</div>

						<div className='col-md-6'>
							<div className='form-group row'>
								<label className='col-sm-3 col-form-label'>Priority</label>
								<div className='col-sm-9'>
									<input
										type='number'
										className='form-control'
										name='priority'
										id='Priority'
										placeholder='Priority'
										onChange={handleChange}
										// value={AddCategory.priority}
									/>
								</div>
							</div>
						</div>

						<div className='col-md-6'>
							<div className='form-group row'>
								<label className='col-sm-3 col-form-label'>Status</label>
								<div className='col-sm-9'>
									<select
										name='active'
										className='form-control'
										// value={AddCategory.active}
										onChange={handleChange}>
										<option>Select Status</option>
										<option value='true' name='active'>
											Active
										</option>
										<option value='false' name='inactive'>
											Inactive
										</option>
									</select>
								</div>
							</div>
						</div>
					</div>

					<div className='card-footer'>
						<div className='row float-right p-3'>
							<button onClick={onSave} className='btn btn-grd-disabled mr-2'>
								<i className='icofont icofont-save'></i> Save
							</button>
							{/* )} */}
							<Link
								to={'/ServiceTypeMaster/quickService'}
								className='btn btn-outline-dark'>
								{' '}
								Cancel{' '}
							</Link>
						</div>
					</div>
				</div>
			</div>
  )
}

export default AddQuickService